import ApiKeyQuickAccess from '@/components/API/ApiKeyQuickAccess';
import QueriesLimitTable from '@/components/API/QueriesLimitTable';
import SwaggerAPI from '@/components/API/SwaggerAPI';
import ApiConsole from '@/components/API/Console/ApiConsole';
import { isNativeApiConsoleEnabled } from '@/components/API/Console/isNativeApiConsoleEnabled';
import ConsoleCollapsibleCard from './ConsoleCollapsibleCard';

type InteractiveConsoleProps = {
  fullHeight?: boolean;
};

export default function InteractiveConsole({ fullHeight = false }: InteractiveConsoleProps) {
  if (isNativeApiConsoleEnabled()) {
    if (fullHeight) return <ApiConsole />;
    return (
      <div>
        <QueriesLimitTable />
        <div className="mt-4">
          <ApiConsole />
        </div>
      </div>
    );
  }

  return (
    <div className={fullHeight ? 'flex flex-col gap-3 min-h-0' : undefined}>
      {fullHeight ? (
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          <ConsoleCollapsibleCard title="Your API key" summary="Authorize in Swagger">
            <ApiKeyQuickAccess embedded />
          </ConsoleCollapsibleCard>
          <ConsoleCollapsibleCard title="Usage limits" summary="API & Web quotas">
            <QueriesLimitTable compact />
          </ConsoleCollapsibleCard>
        </div>
      ) : (
        <QueriesLimitTable />
      )}
      <SwaggerAPI
        style={
          fullHeight
            ? {
                width: '100%',
                minHeight: 'calc(100vh - 160px)',
                height: 'calc(100vh - 160px)',
                backgroundColor: 'black',
              }
            : undefined
        }
      />
    </div>
  );
}
